import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "chart-container" }
const _hoisted_2 = { class: "chart-controls" }

import { PropType, ref, watchEffect } from 'vue';
import { Chart, Tooltip, Legend, LinearScale, Colors, ChartOptions, ChartData, TimeScale, PointElement, LineElement } from 'chart.js';
import { Line } from 'vue-chartjs';
import '../../services/chartJsDateFnsAdapter.js';
import { BIconZoomOut } from 'bootstrap-icons-vue';
import zoomPlugin from 'chartjs-plugin-zoom';
import { Player } from '../../../shared/app/models/index.js';
import { apiGetPlayerRatingHistory } from '../../apiClient.js';
import { RatingCategory } from '../../../shared/app/ratingUtils.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppPlayerRatingChart',
  props: {
    player: {
        type: Object as PropType<Player>,
        required: true,
    },
},
  emits: ["timeRangeUpdated"],
  setup(__props, { expose: __expose, emit: __emit }) {



const emit = __emit;

Chart.register(
    LinearScale,
    TimeScale,
    PointElement,
    LineElement,
    zoomPlugin,
    Tooltip,
    Legend,
    Colors,
);

const ratingChart = ref<HTMLElement>();
const ratingChartData = ref<null | ChartData<'line', { x: Date, y: number }[]>>(null);
const currentRatingCategory = ref<RatingCategory>('overall');

watchEffect(async () => {
    const ratings = await apiGetPlayerRatingHistory(__props.player.publicId, currentRatingCategory.value);

    if (null === ratings) {
        return;
    }

    ratingChartData.value = {
        datasets: [
            {
                data: ratings.map(rating => ({
                    x: rating.createdAt,
                    y: rating.rating,
                })),
            },
        ],
    };
});

const ratingChartOptions: ChartOptions<'line'> = {
    scales: {
        x: {
            type: 'time',
            suggestedMax: new Date() as unknown as string,
            time: {
                minUnit: 'day',
            },
        },
    },
    plugins: {
        legend: {
            display: false,
        },
        zoom: {
            zoom: {
                mode: 'x',
                drag: {
                    enabled: true,
                },
                onZoom: ({ chart }) => {
                    if (1 === chart.getZoomLevel()) {
                        isZoomed.value = false;
                        emit('timeRangeUpdated', null, null);
                    } else {
                        isZoomed.value = true;
                        emit('timeRangeUpdated', new Date(chart.scales.x.min), new Date(chart.scales.x.max));
                    }
                },
            },
        },
    },
    transitions: {
        zoom: {
            animation: {
                duration: 400,
            },
        },
    },
    animation: {
        duration: 200,
    },
    maintainAspectRatio: false,
};

const resetZoom = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (ratingChart.value as any)?.chart.resetZoom('zoom');
    isZoomed.value = false;
    emit('timeRangeUpdated', null, null);
};

const isZoomed = ref(false);

const showRatingCategory = (category: RatingCategory): void => {
    currentRatingCategory.value = category;
    resetZoom();
};

__expose({
    showRatingCategory,
    currentRatingCategory,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isZoomed.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: resetZoom,
            class: "btn btn-outline-primary btn-sm",
            title: "Reset zoom"
          }, [
            _createVNode(_unref(BIconZoomOut))
          ]))
        : _createCommentVNode("", true)
    ]),
    (null !== ratingChartData.value)
      ? (_openBlock(), _createBlock(_unref(Line), {
          key: 0,
          ref_key: "ratingChart",
          ref: ratingChart,
          data: (ratingChartData.value as unknown as ChartData<'line'>),
          options: ratingChartOptions,
          "aria-label": "Chart of rating history."
        }, null, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
}
}

})